(() => {
  const menuButton = document.querySelector('[data-menu-button]');
  const menu = document.querySelector('[data-menu]');

  if (menuButton && menu) {
    const label = menuButton.querySelector('[data-menu-label]');
    const setOpen = (open) => {
      menu.classList.toggle('is-open', open);
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) {
        const next = open ? label.dataset.closeLabel : label.dataset.openLabel;
        if (next) label.textContent = next;
      }
    };

    menuButton.addEventListener('click', () => {
      setOpen(!menu.classList.contains('is-open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });
  }

  document.querySelectorAll('[data-waitlist-submit]').forEach((button) => {
    const form = button.closest('form');
    if (!form) return;
    form.addEventListener('submit', () => {
      button.disabled = true;
    });
  });

  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const jsonEl = section.querySelector('[data-product-variants]');
  const form = section.querySelector('[data-product-form]') || section.querySelector('.product-form');
  const idInput = section.querySelector('[data-variant-id]');
  const addButton = section.querySelector('[data-add]');
  const priceEl = section.querySelector('[data-product-price]');
  if (!jsonEl || !form || !idInput) return;

  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  const selected = () =>
    Array.from(section.querySelectorAll('[data-variant-selects] fieldset')).map((set) => {
      const checked = set.querySelector('input:checked');
      return checked ? checked.value : '';
    });

  const matchVariant = () => {
    const opts = selected();
    return variants.find((variant) =>
      opts.every((value, index) => variant[`option${index + 1}`] === value)
    );
  };

  form.addEventListener('change', () => {
    const variant = matchVariant();
    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = addButton.dataset.unavailableLabel || 'Unavailable';
      }
      return;
    }

    idInput.value = variant.id;

    const amount = priceEl && priceEl.querySelector('[data-price-amount]');
    if (amount) {
      if (variant.price_formatted) amount.textContent = variant.price_formatted;
      amount.setAttribute('data-price-cents', String(variant.price));
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.dataset.addLabel || 'Add to cart'
        : addButton.dataset.soldLabel || 'Sold through';
    }
  });
})();
